import { compact } from 'lodash-es';
import { DropdownMenu, TableList, TableListActions, Typography } from 'seagull';
import { CopyFill, TrashLine } from 'seagull/icons';
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { serviceTemplateModel } from "../../../models";
import { Accounting } from "../../../types/api.model";
import { billingTriggerLabel, ColumnId, occurrenceLabel } from "./CommonServicesPage.utils";
import styles from "./RowItem.module.scss";
import { ServiceRowName } from "./ServiceRowName";
import { ServiceRowPrice } from "./ServiceRowPrice/ServiceRowPrice";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function RowItem(_ref) {
  let {
    service,
    qboItemsById,
    xeroItemsById,
    serviceNameValidation,
    onInlineEdit,
    onEdit,
    onDuplicate,
    onDelete,
    onInputFocus,
    onInputBlur,
    columns,
    isHeightFluid
  } = _ref;
  const {
    IN_STAGES_OCCURENCE = false
  } = useFeatureFlags();
  const qboIntegratedId = serviceTemplateModel.integratedId({
    serviceTemplate: service,
    accounting: Accounting.QBO
  });
  const xeroIntegratedId = serviceTemplateModel.integratedId({
    serviceTemplate: service,
    accounting: Accounting.Xero
  });
  function nameColumn() {
    var _qboItemsById$qboInte, _xeroItemsById$xeroIn;
    return /*#__PURE__*/_jsx(ServiceRowName, {
      onInputFocus: onInputFocus,
      onInputBlur: onInputBlur,
      service: service,
      serviceNameValidation: serviceNameValidation,
      onInlineEdit: onInlineEdit,
      qboServiceDisplay: qboIntegratedId && ((_qboItemsById$qboInte = qboItemsById[qboIntegratedId]) === null || _qboItemsById$qboInte === void 0 ? void 0 : _qboItemsById$qboInte.name),
      xeroServiceDisplay: xeroIntegratedId && ((_xeroItemsById$xeroIn = xeroItemsById[xeroIntegratedId]) === null || _xeroItemsById$xeroIn === void 0 ? void 0 : _xeroItemsById$xeroIn.name)
    });
  }
  function occurenceColumn() {
    return /*#__PURE__*/_jsx(Typography, {
      skin: "secondary",
      children: occurrenceLabel(service.billing, IN_STAGES_OCCURENCE)
    });
  }
  function billingColumn() {
    return /*#__PURE__*/_jsx(Typography, {
      ellipsis: true,
      skin: "secondary",
      children: billingTriggerLabel(service.billing, IN_STAGES_OCCURENCE)
    });
  }
  function includedServicesColumn() {
    var _service$bundle;
    return /*#__PURE__*/_jsx(Typography, {
      skin: "secondary",
      "data-testid": "service-library-row-included-services",
      children: /*#__PURE__*/_jsx("ul", {
        className: styles.includedServices,
        children: (_service$bundle = service.bundle) === null || _service$bundle === void 0 ? void 0 : _service$bundle.services.map((_ref2, index) => {
          let {
            name
          } = _ref2;
          return /*#__PURE__*/_jsx("li", {
            children: name
          }, "".concat(service.id, "-").concat(index));
        })
      })
    });
  }
  function rateColumn() {
    return /*#__PURE__*/_jsx(ServiceRowPrice, {
      service: service,
      onInlineEdit: onInlineEdit,
      onInputFocus: onInputFocus,
      onInputBlur: onInputBlur
    });
  }
  function getColumnItems() {
    const columnsMap = {
      [ColumnId.Name]: nameColumn,
      [ColumnId.Rate]: rateColumn,
      [ColumnId.BillingOccurance]: occurenceColumn,
      [ColumnId.BillingTrigger]: billingColumn,
      [ColumnId.IncludedServices]: includedServicesColumn
    };
    return compact(columns.map(column => ({
      value: columnsMap[column]()
    })));
  }
  return /*#__PURE__*/_jsx(TableList.Row, {
    "data-testid": "service-library-row",
    rowId: service.id,
    size: isHeightFluid ? 'fluid' : 'medium',
    actionColumn: /*#__PURE__*/_jsxs(TableListActions, {
      buttonText: "Edit",
      testId: "service-library-row-actions",
      onClickButton: onEdit,
      children: [/*#__PURE__*/_jsx(DropdownMenu.Item, {
        iconStart: /*#__PURE__*/_jsx(CopyFill, {}),
        "data-testid": "service-library-row-duplicate",
        onClick: onDuplicate,
        children: "Duplicate"
      }), /*#__PURE__*/_jsx(DropdownMenu.Item, {
        skin: "error",
        iconStart: /*#__PURE__*/_jsx(TrashLine, {}),
        "data-testid": "service-library-row-delete",
        onClick: onDelete,
        children: "Delete"
      })]
    }),
    items: getColumnItems()
  });
}